import { render, staticRenderFns } from "./quotation_template.vue?vue&type=template&id=971d57d2&scoped=true&"
import script from "./quotation_template.vue?vue&type=script&lang=js&"
export * from "./quotation_template.vue?vue&type=script&lang=js&"
import style0 from "./quotation_template.vue?vue&type=style&index=0&id=971d57d2&prod&lang=scss&scoped=true&"
import style1 from "./quotation_template.vue?vue&type=style&index=1&id=971d57d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971d57d2",
  null
  
)

export default component.exports